import React, { FC } from 'react'

const LoadingPage: FC = () => {
  return <div />
}

export default LoadingPage
